export function isMyAppWKWebView() {
    return Boolean(
      window.webkit?.messageHandlers?.loadData
    );
  }